import { render, staticRenderFns } from "./BaseCardIcon.vue?vue&type=template&id=593a3acc&scoped=true&"
import script from "./BaseCardIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseCardIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCardIcon.vue?vue&type=style&index=0&id=593a3acc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a3acc",
  null
  
)

export default component.exports